import { render } from "./MinistryManagerProducts.vue?vue&type=template&id=9b7c4ac0&scoped=true"
import script from "./MinistryManagerProducts.vue?vue&type=script&lang=js"
export * from "./MinistryManagerProducts.vue?vue&type=script&lang=js"

import "./MinistryManagerProducts.vue?vue&type=style&index=0&id=9b7c4ac0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b7c4ac0"]])

export default __exports__